export async function promiseDelay(delay: number = 0): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => resolve(), delay);
  });
}
